const doc = [({"en":({"js":({"admin":({"team_surveys":({"table":({"regions":"Regions"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;